import { render, staticRenderFns } from "./view-contact.vue?vue&type=template&id=2b090d5e&scoped=true&"
import script from "./view-contact.vue?vue&type=script&lang=js&"
export * from "./view-contact.vue?vue&type=script&lang=js&"
import style0 from "./view-contact.vue?vue&type=style&index=0&id=2b090d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b090d5e",
  null
  
)

export default component.exports